import React, { useState, useContext, useEffect } from 'react';
import { ListGroup, Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Search from 'src/components/Form/search';
import { SearchFilter } from 'src/helper/search';
import { ConfigContext } from 'src/contexts/ConfigContext';
import { sanitizeValue } from 'src/utils/custom-formatters';
import { useFkContext } from 'src/contexts/FkContext';
import { useCookies } from 'react-cookie';
import AccountsReset from './AccountsReset';
import { getCountryFlagUrl } from 'src/utils/utils';

export default function FlipkartProfiles() {

  const { fkState, fkDispatch } = useFkContext()
  const [cookies, setCookie, removeCookie] = useCookies();
  const [showAccDropdown, setShowAccDropdown] = useState(false);
  const flipkartProfile = JSON.parse(sessionStorage.getItem('flipkartProfile'))
  const [defaultActive, setDefaultActive] = useState(flipkartProfile ? flipkartProfile : {})
  const [valueSearch, setValueSearch] = useState("")
  const [getProfiles, setProfiles] = useState({
    data: Array.isArray(fkState?.flipkartProfiles) ? fkState?.flipkartProfiles : [],
    filteredData: []
  })

  useEffect(() => {
    setProfiles({
      data: fkState?.flipkartProfiles,
      filteredData: []
    })
    let profile = JSON.parse(sessionStorage.getItem('flipkartProfile'))
    setDefaultActive(profile)
  }, [fkState?.flipkartProfiles])

  const configContext = useContext(ConfigContext);
  const { rtlLayout } = configContext.state;

  useEffect(() => {
    setValueSearch("")
    setProfiles({
      data: Array.isArray(fkState?.flipkartProfiles) ? fkState?.flipkartProfiles : [],
      filteredData: []
    })
  }, [fkState?.flipkartProfiles])

  useEffect(() => {
    // DISABLED: sessionStorage is tab-specific, no need to reload on focus
    // Each tab maintains its own profile selection independently
    /*
    let reloadTimeout = null;
    let lastFocusTime = 0;
    const RELOAD_DEBOUNCE_TIME = 5000; // 5 seconds minimum between reloads

    const handleWindowFocus = () => {
      const now = Date.now();
      
      // Prevent reload if we just focused recently
      if (now - lastFocusTime < RELOAD_DEBOUNCE_TIME) {
        console.log('Flipkart window focus ignored - too recent');
        return;
      }
      
      lastFocusTime = now;
      
      // Clear any existing timeout
      if (reloadTimeout) {
        clearTimeout(reloadTimeout);
      }
      
      // Debounce the reload check
      reloadTimeout = setTimeout(() => {
        try {
          const localProfile = JSON.parse(sessionStorage.getItem('flipkartProfile'));
          if (defaultActive && localProfile && localProfile?.Value !== defaultActive.Value) {
            console.log('Flipkart profile mismatch detected, reloading...', { localProfile, defaultActive });
            window.location.reload();
          } else {
            console.log('Flipkart profile sync check passed');
          }
        } catch (error) {
          console.error('Error in Flipkart window focus handler:', error);
        }
      }, 1000); // 1 second delay to prevent rapid reloads
    }
    
    window.addEventListener('focus', handleWindowFocus);
    return () => {
      if (reloadTimeout) {
        clearTimeout(reloadTimeout);
      }
      window.removeEventListener('focus', handleWindowFocus);
    };
    */
  }, [defaultActive]);


  const getTableRows = () => {
    if (valueSearch !== '') {
      return getProfiles.filteredData;
    } else {
      return getProfiles.data;
    }
  };

  const searchInputHandle = async (e) => {
    const keyword = sanitizeValue(e.target.value);
    console.log("keyword", keyword);
    const { data, filteredData } = await SearchFilter(getProfiles.data, keyword);

    if (keyword !== '') {
        setProfiles({ data, filteredData });
    }
    else {
        setProfiles({ data, filteredData });
    }
    setValueSearch(keyword);
  }

  const handleSelect = (selectedItem) => {
      setShowAccDropdown(!showAccDropdown)
      setDefaultActive(selectedItem)
      sessionStorage.removeItem("flipkartProfile")
      sessionStorage.setItem('flipkartProfile', JSON.stringify(selectedItem))
      document.getElementById('fullPageLoader').style.visibility = 'visible';
      setTimeout(() => {
      if(window.location.href.indexOf('plan-expired') > -1) {
        window.location.href = '/summary/flipkart'
      } else {
        window.location.reload();
      }
    }, 100);
  }

  useEffect(() => {
    if (showAccDropdown) {
      document.body.classList.add('overflow-hidden');
    } else {
      document.body.classList.remove('overflow-hidden');
    }
  }, [showAccDropdown]);

  const profilesList = valueSearch != '' ? getProfiles.filteredData : getProfiles.data;

  console.log("profilesList", {profilesList})

  // if(!defaultActive?.countryCode) return null

  return (
    <ListGroup.Item as="li" bsPrefix="" className='ch_toggle'>
      <Dropdown
        alignRight={!rtlLayout}
        className="select-account"
        show={showAccDropdown}
        onToggle={() => {
          if(profilesList.length > 1) {
            setShowAccDropdown(!showAccDropdown)
          }
        }}
      >
        <Dropdown.Toggle as="li" id="dropdown-basic" onClick={() => {
          if(profilesList.length > 1) {
            setShowAccDropdown(!showAccDropdown)
          }
        }} className='cursor-pointer'>
          <div className="text-right d-flex flex-column l-base align-items-end pr-2 drop-crd">
            <div className="f-w-600 f-14 d-flex align-items-center text-left">
              <img
                alt="country-img"
                src={getCountryFlagUrl(defaultActive?.countryCode)}
                className="country_flag_drop"
              />
              <div className="d-flex flex-column f-10">
                <h4 className='f-w-600 f-11 d-flex align-items-center'>
                  <span className='profile-name-truncate'>{defaultActive?.accountInfo?.name}</span>
                  <p className={`f-w-500 ml-2 ${defaultActive?.V2 === true || defaultActive?.report_type == 'seller' ? 'txt-theme' : 'text-success'} `}>({defaultActive?.V2 || defaultActive?.report_type == 'seller' ? 'seller' : 'ads'})</p>
                </h4>
                {defaultActive?.accessLevel ?
                    <span className="f-10 text-left w-100 f-w-500 spld-bder f-8F8F91">
                      Role: <b className="f-w-600 f-10 f-333843">{defaultActive?.accessLevel}</b>
                    </span>
                  : null}
              </div>
            </div>
            {/* <small className="f-10 bg-blur px-2 py-1 rounded-10 txt-theme">{defaultActive?.map((select) => select?.countryCode)}</small> */}
          </div>
        </Dropdown.Toggle>

        <Dropdown.Menu alignRight className="themebg notification notification-scroll">
          {showAccDropdown && <>
          <div className="noti-head" style={{
            height: '60px',
            padding: '0px'
          }}>
            {/* <h6 className="d-inline-block m-b-0 f-w-700 f-14 text-dark">ACCOUNTS</h6> */}
            <AccountsReset />
          </div>
          <div className="px-3 pt-3 pb-1">
            <Search searchValue={valueSearch} callBack={searchInputHandle} />
          </div>
          <PerfectScrollbar className="min-hight-150 max-height-300">
            <ListGroup as="ul" bsPrefix=" " variant="flush" className="noti-body">
                {profilesList && profilesList.map((AMSprofiles, index) => (
                  <ListGroup.Item
                    as="li"
                    bsPrefix=" "
                    className={'n-title px-0 pt-2'}
                    key={index}
                    onClick={() => handleSelect(AMSprofiles)}
                  >
                    <Link
                      to="#"
                      className={`dropdown-item d-flex align-items-center justify-content-between ${
                        defaultActive?.profileId == AMSprofiles.profileId ? 'active' : ''
                      }`}
                    >
                      <section className="d-flex align-items-center" title={AMSprofiles?.accountInfo?.name}>
                        <img
                          src={getCountryFlagUrl(AMSprofiles?.countryCode)}
                          alt=""
                          className="wid-30 hei-25 mr-4"
                        />

                        <div>
                        <h4 className='f-w-600 f-13 d-flex align-items-center'>
                          <span className='profile-name-truncate'>{AMSprofiles?.accountInfo?.name}</span>
                          <p className={`f-w-500 ml-2 ${AMSprofiles?.V2 === true || AMSprofiles?.report_type == 'seller' ? 'txt-theme' : 'text-success'} `}>({AMSprofiles?.V2 || AMSprofiles?.report_type == 'seller' ? 'seller' : 'ads'})</p>
                        </h4>
                          {/* {AMSprofiles.accessLevel ? (
                            <p className="f-13 mb-0 f-w-500">
                              Role: &nbsp; <b className="f-w-600 pr-1">{AMSprofiles.accessLevel}</b> |{' '}
                            </p>
                          ) : null} */}
                          {/* <p className="f-13 mb-0 f-w-500">{AMSprofiles.profileId}</p> */}
                          {/* <p className="f-12 text-secondary f-w-500 d-flex align-items-center"> */}
                        </div>
                      </section>
                    </Link>
                  </ListGroup.Item>
                ))}
                {profilesList && profilesList.length === 0 && (
                  <div className="hei-300 w-100 d-flex align-items-center justify-content-center f-w-700 txt-danger">
                    {' '}
                    No Profiles Found
                  </div>
                )}
            </ListGroup>
          </PerfectScrollbar>
          {/* <div className="noti-footer py-2 text-left">
            <Link to="/profile" className="mb-1">
              Manage Your Accounts
            </Link>
            <br />
            <Link to="/addaccount">Add a new account</Link>
          </div> */}
          </>}
        </Dropdown.Menu>
      </Dropdown>
    </ListGroup.Item>
  );
}
